import route from 'route';

const mainRoute = route.DASHBOARD;
const organizationRoute = `${mainRoute}/organization`;

export default {
  COMPANY_LIST: `${organizationRoute}/company-list`,
  COMPANY_LIST_TAB: `${organizationRoute}/company-list/:tab`,
  COMPANY_LIST_FILTER: `${organizationRoute}/company-list/:tab/page/:page`,
  COMPANY_DETAIL: `${organizationRoute}/company-detail/:id`,
  COMPANY_EDIT: `${organizationRoute}/company-detail/:id/edit`,
  COMPANY_REGISTER: `${organizationRoute}/company-register`,
  EMPLOYEE_LIST: `${organizationRoute}/employee-list`,
  EMPLOYEE_LIST_TAB: `${organizationRoute}/employee-list/:tab`,
  EMPLOYEE_LIST_FILTER: `${organizationRoute}/employee-list/:tab/page/:page`,
  EMPLOYEE_DETAIL: `${organizationRoute}/employee-detail/:id`,
  EMPLOYEE_EDIT: `${organizationRoute}/employee-detail/:id/edit`,
  EMPLOYEE_REGISTER: `${organizationRoute}/employee-register`,
  EMPLOYEE_ROLE_LIST: `${organizationRoute}/employee-role-list`,
  EMPLOYEE_ROLE_LIST_FILTER: `${organizationRoute}/employee-role-list/page/:page`,
  EMPLOYEE_ROLE_REGISTER: `${organizationRoute}/employee-role-register`,
  EMPLOYEE_ROLE_DETAIL: `${organizationRoute}/employee-role-detail/:id`,
  EMPLOYEE_ROLE_EDIT: `${organizationRoute}/employee-role-detail/:id/edit`,
};
